module.exports = __webpack_public_path__ + "img/getting-started.130db71c.png";